import type { UserProfile } from '@cronos-app/api';
import { getUserProfile, updateUserProfile } from '@cronos-app/api';
import { currentWallet } from '@cronos-app/wallet';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useIsAuthenticated } from './useIsAuthenticated';

export const useUserProfile = (userAddress?: string) => {
  const walletAddress = currentWallet.useAccount() ?? '';
  const isAuthenticated = useIsAuthenticated().data;

  return useQuery(
    ['useUserProfile', walletAddress, userAddress],
    () => {
      if (userAddress) {
        // todo cover.lv mock data
        const userProfile: UserProfile = {
          id: 888,
          name: '',
          address: userAddress,
        };
        return userProfile;
      } else {
        return getUserProfile(walletAddress);
      }
    },
    {
      enabled: (!!walletAddress && !!isAuthenticated) || !!userAddress,
    },
  );
};

export const useUpdateUserProfile = (onSuccess?: () => void) => {
  const walletAddress = currentWallet.useAccount() ?? '';
  const isAuthenticated = useIsAuthenticated().data;
  const queryClient = useQueryClient();

  return useMutation(
    async ({ name }: { name: string }) => {
      if (!isAuthenticated) throw new Error('user is not authenticated');
      if (!walletAddress) throw new Error('user is not connected');
      await updateUserProfile(walletAddress, name);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['useUserProfile']);
        onSuccess?.();
      },
    },
  );
};
